import { DataVariableType } from '@empathy/global/data';

import { QuestionOption } from './question-option.model';

export class DataVariable {
  id: string;
  typeId: DataVariableType;
  dataVariableKeyName: string;
  groupId: number;
  options: QuestionOption[];
  useAsSurveyResultFilterInd: boolean;
}
